<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="$l('tips_search') || '单号 搜索...'"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                    >{{ $l('INDEX.advanced_search') || '高级搜索' }}</b-button
                  >
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="openEditPage({ pageType: 'add' })"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="800px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-position="top" size="small">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$l('INDEX.Status') || '有效状态'">
              <el-checkbox-group v-model="form.taskStatusList">
                <el-checkbox label="N">{{
                  $l('task_status_new') || '新增'
                }}</el-checkbox>
                <el-checkbox label="Y">{{
                  $l('task_status_publish') || '已发布'
                }}</el-checkbox>
                <el-checkbox label="F">{{
                  $l('task_status_done') || '已完成'
                }}</el-checkbox>
                <el-checkbox label="O">{{
                  $l('task_status_close') || '已结束'
                }}</el-checkbox>
                <el-checkbox label="D">{{
                  $l('task_status_deleted') || '已删除'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_task_no') || '任务单号'">
              <el-input
                v-model.trim="form.taskNo"
                :placeholder="$l('tips_form_label_task_no') || '请输入任务单号'"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_taskRangeFlag') || '任务范围'">
              <dict-select
                clearable
                v-model="form.taskRangeFlag"
                filterable
                size="small"
                url="/sys/common/dict/system"
                :body="taskRangeFlagParams"
                :placeholder="
                  $l('tips_form_label_taskRangeFlag') || '请选择任务范围'
                "
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$l('INDEX.create_date') || '创建时间'">
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.createDateBegin"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('INDEX.Please select a start time') ||
                          '请选择开始时间'
                      "
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.createDateEnd"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('INDEX.Please select an end time') ||
                          '请选择结束时间'
                      "
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item
                  :label="
                    $l('INDEX.table_label_modification_date') || '修改时间'
                  "
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyDateBegin"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('INDEX.Please select a start time') ||
                          '请选择开始时间'
                      "
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyDateEnd"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('INDEX.Please select an end time') ||
                          '请选择结束时间'
                      "
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  taskStatusList: ['N', 'Y', 'F', 'O'],
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      taskRangeFlagParams: { dictType: 'taskRangeFlag' },
    }
  },
  created() {
    this.query()
    this.$eventBus.$on('sampleStockSale', () => {
      this.query()
    })
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    openEditPage({ pageType, params = {} }) {
      this.$router.push({
        name: 'samplemanage-sampleStockCheck-detail',
        params: { ...params, pageType },
      })
    },
    getForm() {
      return this.form
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
